import React, { useEffect, useState } from "react";
import OtpBox from "../../Components/Input/Otp";
import {
  clearLocalToken,
  getLocalToken,
  setLocalToken,
} from "../../services/token";
import { decryptor, encryptor, getPayloadHash } from "../../services/helper";
import { postFormDataCall } from "../../services/apiCall";
import { useNavigate } from "react-router-dom";
import { makeErrorToast, makeSuccessToast } from "../../Components/Toast/Toast";

const OTP = () => {
  const navigate = useNavigate();

  const otpLength = 6;

  const [otp, setOtp] = useState(new Array(otpLength).fill(""));
  const [error, setError] = useState("");
  const [verificationPayload, setVerificationPayload] = useState({});

  const isOtpComplete = otp.every((digit) => digit.trim() !== "");

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!isOtpComplete) {
      setError("Please enter the complete OTP.");
      return;
    }

    setError("");

    const payload = {
      ...verificationPayload,
      otp: otp.join(""),
    };

    const dataToSend = getPayloadHash({ data: payload });
    let response = await postFormDataCall(
      "/verify_account",
      {},
      { data: dataToSend }
    );

    if (response.success && response?.JOBS_APP) {
      const encryptedData = encryptor({ payload: response?.JOBS_APP });
      setLocalToken(encryptedData);
      makeSuccessToast({
        message: "Account verified successfully. You can now login",
      });
      clearLocalToken("verification-gigz");

      if (response?.JOBS_APP?.usertype === "User") {
        navigate("/user");
      } else if (response?.JOBS_APP?.usertype === "Company") {
        navigate("/company");
      }
    } else {
      makeErrorToast({ message: response?.msg || "" });
    }
  };

  const getInitialData = () => {
    const key = getLocalToken("verification-gigz") || null;
    if (key) {
      let decodedData = decryptor({ encryptedData: key });
      if (decodedData) {
        decodedData = JSON.parse(decodedData);
        setVerificationPayload({
          user_id: decodedData?.user_id,
          phone: decodedData?.phone,
        });
      }
    } else {
      navigate("/auth/sign-in");
    }
  };

  useEffect(() => {
    getInitialData();
  }, []);

  return (
    <div className="size-full flex flex-col justify-center items-center">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h2 className="text-3xl font-semibold text-gray-800 text-center mb-2">
          Verify OTP
        </h2>
        <p className="text-gray-600 text-center mb-4">
          Please enter the 6-digit OTP sent to your Whatsapp
        </p>

        <form className="w-full" onSubmit={submitHandler}>
          <div className="w-full flex flex-col gap-4 mb-4">
            <OtpBox length={otpLength} value={otp} setValue={setOtp} />
            {error && <p className="text-red-500 text-sm">{error}</p>}
          </div>

          <button
            type="submit"
            className={`w-full py-2 rounded-lg text-white font-semibold ${
              isOtpComplete
                ? "bg-blue-600 hover:bg-blue-700"
                : "bg-gray-400 cursor-not-allowed"
            }`}
            disabled={!isOtpComplete}
            aria-label="Verify OTP"
          >
            Verify
          </button>
        </form>

        <p className="text-sm text-gray-600 text-center mt-4">
          Didn't receive the code?{" "}
          <button
            type="button"
            className="text-blue-600 hover:underline font-medium"
          >
            Resend OTP
          </button>
        </p>
      </div>
    </div>
  );
};

export default OTP;
